// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { TxnBatch } from './txn-batch';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TxnDetail extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  txnDetailId!: number;
  chequeNumber?: string;
  debitCreditIndicator?: string;
  referenceNumber?: string;
  secondaryReferenceNo?: string;
  transactionAmount?: number;
  transactionCode?: string;
  transactionDate?: Date;
  transactionDescription?: string;
  txnBatchId!: number;
  txnBatch!: TxnBatch;
}

